import * as Scrivito from "scrivito";
import IconWidget from "../IconWidget/IconWidgetClass";
import TableRowWidget from "../TableRowWidget/TableRowWidgetClass";
import tableWidgetIcon from "../../assets/images/table_widget.svg";
import TextWidget from "../TextWidget/TextWidgetClass";
import TableCellWidget from "../TableCellWidget/TableCellWidgetClass";

Scrivito.provideEditingConfig("TableWidget", {
  title: "Table",
  thumbnail: tableWidgetIcon,
  attributes: {
    headers: {
      description:
        "If you wish to add an empty header set 'null-number' as a title, i.e. null-1",
    },
    rows: {
      title: "Rows",
    },
    summaryRows: {
      title: "Summary rows",
    },
    caption: {
      title: "Caption",
      description:
        "Accessible caption for the table, not visible in the frontend",
    },
    description: {
      title: "Description",
      description:
        "Accessible description for the table, not visible in the frontend",
    },
  },
  properties: ["caption", "description", "headers", "firstColumnAsHeader"],
  propertiesGroups: [
    {
      title: "Rows",
      properties: ["rows"],
      key: "rows",
    },
    {
      title: "summary rows",
      properties: ["summaryRows"],
      key: "summaryRows",
    },
  ],
  initialContent: {
    headers: ["Header 1", "Header 2", "Header 3", "Header 4"],
    rows: [
      new TableRowWidget({
        cells: [
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
        ],
      }),
      new TableRowWidget({
        cells: [
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({
            cell: [new IconWidget({ icon: "las la-check", size: "200" })],
          }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({
            cell: [new IconWidget({ icon: "las la-times", size: "200" })],
          }),
        ],
      }),
      new TableRowWidget({
        cells: [
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
          new TableCellWidget({ cell: [new TextWidget({ text: "data" })] }),
        ],
      }),
    ],
    summaryRows: [
      new TableRowWidget({
        cells: [
          new TableCellWidget({ cell: [new TextWidget({ text: "Total:" })] }),
          new TableCellWidget({ cell: [new TextWidget({})] }),
          new TableCellWidget({ cell: [new TextWidget({})] }),
          new TableCellWidget({ cell: [new TextWidget({})] }),
        ],
      }),
    ],
  },
});
